/**
 * Implementation of step one in creating Monitor
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React, { FC, ReactElement, ReactNode, useState } from "react";
import { VscJson } from "react-icons/vsc";
import { BsArrowRight } from "react-icons/bs";
import MetroSelect from "../MetroSelect";
import { MdOutlineDesktopWindows } from "react-icons/md";
import { IoLockClosed } from "react-icons/io5";
import Select from "../Select";

const Option = ({ label, icon, description }: { label: string, icon: ReactNode, description: string }) => (
  <div className="bg-gray-100 flex flex-col items-center justify-center py-3 px-2 rounded-lg">
    <div className="bg-white rounded-lg w-10 h-10 flex justify-center items-center">
      { icon }
    </div>
    <p className="text-center text-gray-600 mt-2">{label}</p>
    {/* <p className="text-center text-gray-600 text-sm">{description}</p> */}
  </div>
)

export default function StepOne() {
  const [monitorType, setMonitorType] = useState(1)
  const [url, setUrl] = useState("")
  const [frequency, setFrequency] = useState(1);

  const monitorTypes = [
    {
      "label": "API",
      "element": <Option label="API" description="API expects a JSON response."
        icon={<VscJson size={32} className="text-violet-500" />}/>
    },
    {
      "label": "WEBSITE",
      "element": <Option label="WEBSITE" description="Website expects a HTML response"
        icon={<MdOutlineDesktopWindows size={28} className="text-sky-600" />} />
    },
    {
      "label": "SSL",
      "element": <Option label="SSL Certificate" description="SSL"
        icon={<IoLockClosed size={26} className="text-teal-500" />} />,
    }
  ]

  const frequencies = [
    {
      label: 30,
      element: <div className="p-3">Every 30 mins</div>
    },
    {
      label: 15,
      element: <div className="p-3">Every 15 mins</div>
    },
    {
      label: 5,
      element: <div className="p-3">Every 5 mins</div>
    },
    {
      label: 1,
      element: <div className="p-3">Every minute</div>
    }
  ]

  return (
    <div>
      <h1 className="text-lg mb-2 mt-2 text-gray-700">What you want to monitor</h1>
      <MetroSelect options={monitorTypes.map(monitor => monitor.element)} 
        selected={monitorType} 
        onSelect={(selected) => setMonitorType(selected as number)} />
      <br/>
      <h1 className="text-lg mt-2 mb-2 text-gray-700">What's your {monitorTypes[monitorType].label.toLowerCase()} URL</h1>
      <div className="relative">
        <input className="input-field-primary w-full pl-20" 
          placeholder="example.com"
          onChange={e => setUrl(e.target.value)}
          value={url}
          />

        <div className="absolute top-0 left-0 h-full">
          <Select options={["http://", "https://"]} />
        </div>
      </div>
      <br/>
      <h1 className="text-lg mt-2 mb-2 text-gray-700">How frequently you want to monitor</h1>
      <MetroSelect options={frequencies.map(frequency => frequency.element)} 
        selected={frequency} 
        onSelect={(selected) => setFrequency(selected as number)} />
      <br/>
      <button className="btn-primary float-right mr-4 px-8">
        Next&nbsp;&nbsp;<BsArrowRight className="icon"/>
      </button>
    </div>
  )
}